import React from "react";

const brandStyles = {

    linkHover: '#68A637', 
    deepBlue: "#394C92", 
};

export default function WhatisOrgavitaz() {
  
  // Inline styles are used for the specific brand colors as seen in the original snippet
  const styles = {
    smallHeading: {
      color: brandStyles.linkHover, 
    },
    bigHeadingSpan: {
      color: brandStyles.deepBlue, 
    },
  };

  return (
    // Section acts as a full-width container for the content
    <section className="py-5 bg-white" id="overview">
      {/* Container centers content and provides max-width for readability */}
      <div className="container text-center px-4"> 
        
        <h2 className="fw-bold mb-4" style={styles.smallHeading}>
          What is Orgavitaz ?
        </h2>
        
        <h6 className="fw-bold mb-5" >
          Orgavitaz is a{" "}
          <span style={styles.bigHeadingSpan}>Complete-Vitamin-Complex</span>{" "}
          ingredient in its whole-food form.
        </h6>
        
        
        {/* First paragraph (lead text) */}
        <p className="lead text-muted mb-4 fs-6 text-start">
          Vital nutrients cannot always be vital natural isolates or synthetics
          that can independently work on deficiencies. They mostly come from{" "}
          <span className="fw-bold">whole-food as a complex</span> and makes it{" "}
          <span className="fw-bold">complete by biological function</span>. Vitamins in whole-food forms are colloidal, in the form of enzymes, coenzymes, peptides, natural metabolites, activators and minerals complexes.
           In the absence of such complexes, the vitamins are less active or inactive or at times harmful. 
        </p>
        
        {/* Second paragraph (lead text) */}
        <p className="lead text-muted fs-6 text-start">
          Orgavitaz offers vitamins and minerals as complexes in its naturally existing form that can control the way the body recognizes, metabolises and absorbs them for bodily functions.
        </p>
        
      </div>
    </section>
  );
}